<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createFinancingSource') }}</h1>
      <div class="form-container">
        <FinancingSourceForm @save="save"></FinancingSourceForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import FinancingSourceForm from '@/components/FinancingSourceForm'

  export default {
    components: {
      DashboardLayout,
      FinancingSourceForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('FinancingSource/create', {
          financingSource: form,
          projectId: this.$route.params.projectId
        }).then(() => {
          this.$router.push({
            name: 'projectDetail',
            params: {
              projectId: this.$route.params.projectId,
              section: 'financingSources'
            }
          })
        })
      }
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'projects', path: 'projects'},
          {
            name: 'projectDetail', path: {
              name: 'projectDetail',
              params: {projectId: this.$route.params.projectId}
            }
          },
          {name: 'createFinancingSource'}
        ]
      }
    }
  }
</script>